<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idServicio" class="form-label">IdServicio</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idServicio" name="idServicio" v-model="datoServicio.idServicio" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombre" name="nombre" v-model="datoServicio.nombre" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarServicio" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditServicio" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdTramite</th>
          <th scope="col">IdPrestador</th>
          <th scope="col">IdServicio</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaDesde</th>
          <th scope="col">FechaHasta</th>
          <th scope="col">Descripcion</th>
          <th scope="col">Estado</th>
          <th scope="col">ServicioNombre</th>
          <th scope="col">PrestadorFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tramite in datosPaginados" :key="tramite.idTramite">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(tramite.idTramite)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(tramite.idTramite)" title="Editar">edit_square</i></td>
          <td>{{tramite.idTramite}}</td>
          <td>{{tramite.idPrestador}}</td>
          <td>{{tramite.idServicio}}</td>
          <td>{{getFormattedDate(tramite.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(tramite.fechaDesde, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(tramite.fechaHasta, 'DD/MM/YYYY')}}</td>
          <td>{{tramite.descripcion}}</td>
          <td>{{tramite.estado}}</td>
          <td>{{tramite.servicioNombre}}</td>
          <td>{{getFormattedDate(tramite.prestadorFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteServicio(tramite.idTramite)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idTramite" class="form-label">IdTramite</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTramite" name="idTramite" v-model="datoTramite.idTramite" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPrestador" class="form-label"> Prestador</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPrestador" name="idPrestador" v-model="datoTramite.idPrestador">
                      <option v-for="prestador in prestadors" :value="prestador.idPrestador" :key="prestador.idPrestador">
                        {{ prestador.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idServicio" class="form-label">IdServicio</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idServicio" name="idServicio" v-model="datoTramite.idServicio" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoTramite.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">FechaDesde</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDesde" name="fechaDesde" v-model="datoTramite.fechaDesde" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">FechaHasta</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaHasta" name="fechaHasta" v-model="datoTramite.fechaHasta" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoTramite.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarTramite" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTramite" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      servicios : [],
      datoServicio : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idServicio: '',
// Variables master
// Variables details
      tramites : [],
      datoTramite : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      prestadors : [],
//      servicios : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idServicio = this.$route.params.p_idservicio
    this.abrirEditar(this.p_idServicio)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoServicio, requiredFields, requiredFieldsText);
    },
    async guardarServicio(){
      if(this.validarForm() === 1){
        try {
          await api.post('/servicios', this.datoServicio)
          swal("Correcto!", "Servicio creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditServicio(){
      if(this.validarForm() === 1){
        try {
          await api.post('/servicios', this.datoServicio)
          swal("Correcto!", "Servicio creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoServicio={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idServicio){
      this.modalWindow = true
      if(idServicio != null){    
           api.get('/vwservicios/'+idServicio).then(resp=>{
          this.datoServicio = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarServicio(){
      this.$router.push('/Servicio')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.tramites.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwtramites/nombre/'+this.nombreBusqueda).then(response=>{
          this.tramites=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.tramites.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwtramites').then(response=>{
      this.tramites=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.tramites.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoServicio, requiredFields, requiredFieldsText);
    },
    async guardarTramite(){
      if(this.validarForm() === 1){
        try {
          this.datoTramite.idServicio = this.datoServicio.idServicio;
          await api.post('/tramites', this.datoTramite)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Tramite creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTramite(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tramites', this.datoTramite)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Tramite creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoTramite={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idTramite){
      this.modalWindow = true
      if(idTramite != null){    
           api.get('/vwtramites/'+idTramite).then(resp=>{
          this.datoTramite = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idTramite){
      this.modalWindow = true
      if(idTramite != null){
        this.$router.push('/tramitemd/'+idTramite)
      }
    },
    async deleteTramite (idTramite) {
      try{
        await api.delete('/tramites/'+idTramite)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPrestadors() {
      fetch('http://localhost:8080/api/v1/prestadors')
        .then(response => response.json())
        .then(data => {
          this.prestadors = data;
        })
        .catch(error => {
          console.error('Error fetching prestadors:', error);
        });
    },
/*     fetchServicios() {
      fetch('http://localhost:8080/api/v1/servicios')
        .then(response => response.json())
        .then(data => {
          this.servicios = data;
        })
        .catch(error => {
          console.error('Error fetching servicios:', error);
        });
    }, */
  },
}
</script>
